export default __webpack_public_path__ + "static/media/reqservice.95a03068.svg";